import { render, staticRenderFns } from "./little.vue?vue&type=template&id=39dd62d0&scoped=true&"
import script from "./little.vue?vue&type=script&lang=js&"
export * from "./little.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dd62d0",
  null
  
)

export default component.exports